var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuCardInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Framework",
    transform: "translate(-619.000000, -317.000000)",
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9-Copy",
    transform: "translate(619.000000, 311.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Menu_Card_Inactive",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C15.553,0 16,0.447 16,1 L16,11 C16,11.553 15.553,12 15,12 L1,12 C0.447,12 0,11.553 0,11 L0,1 C0,0.447 0.447,0 1,0 L15,0 Z M14,10 L14,5 L2,5 L2,10 L14,10 Z M14,3 L14,2 L2,2 L2,3 L14,3 Z M12,9 C11.447,9 11,8.553 11,8 C11,7.447 11.447,7 12,7 C12.553,7 13,7.447 13,8 C13,8.553 12.553,9 12,9 Z M10,9 C9.447,9 9,8.553 9,8 C9,7.447 9.447,7 10,7 C10.553,7 11,7.447 11,8 C11,8.553 10.553,9 10,9 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuCardInactive);
export default __webpack_public_path__ + "static/media/Icon-Menu_Card_Inactive.eda11b3967b8011235931fc4c6430c69.svg";
export { ForwardRef as ReactComponent };